import { Link } from "react-router-dom";
import { AlertCircle } from "@/components/icons";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="max-w-md text-center">
        <AlertCircle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
        <h1 className="text-2xl font-semibold text-navy">Página não encontrada</h1>
        <p className="text-sm text-muted-foreground mt-2">
          O endereço que você tentou abrir não existe ou foi removido.
        </p>
        <Link
          to="/"
          data-testid="not-found-voltar"
          className="inline-flex items-center gap-2 mt-6 h-10 px-4 rounded-lg bg-brand text-white text-sm font-semibold hover:bg-brand-hover"
        >
          Voltar ao início
        </Link>
      </div>
    </div>
  );
}
